import set from "lodash/set";
import get from "lodash/get";
import initialState from "nexia_mobile/flux_like/store/initial_state";

const Store = JSON.parse(JSON.stringify(initialState));

const allListeners = new Map(); // Map<string, Set<(any) => void>>

export function listenToPath(pathString, callback) {
  let listenersForPath;
  if (allListeners.has(pathString)) {
    listenersForPath = allListeners.get(pathString);
  } else {
    listenersForPath = new Set();
    allListeners.set(pathString, listenersForPath);
  }

  if (typeof callback !== "function") {
    throw new Error(
      `Attempted to add a listener for ${pathString} but the callback was not a function`
    );
  }
  listenersForPath.add(callback);
}

export function stopListeningToPath(pathString, callback) {
  if (!allListeners.has(pathString)) {
    throw new Error(
      `Attempted to stop listening to a path for which no listeners were registered: ${pathString}`
    );
  }

  const listenersForPath = allListeners.get(pathString);
  if (!listenersForPath.has(callback)) {
    throw new Error(
      `Attempted to remove a listener callback for path ${pathString}, but the provided callback was not registered`
    );
  }
  listenersForPath.delete(callback);
}

export function setValueAtPath(pathString, newValue) {
  // lodash.set can set both string and array paths, but since this
  // implementation uses paths as a lookup key, only strings are supported
  // (since ["some", "path"] !== ["some", "path"])
  if (typeof pathString !== "string") {
    throw new Error("Attempted to call setValueAtPath with a non-string path");
  }

  const oldValue = get(Store, pathString);
  if (oldValue === newValue) {
    return;
  }

  set(Store, pathString, newValue);

  if (allListeners.has(pathString)) {
    const listenersForPath = allListeners.get(pathString);
    listenersForPath.forEach((callback) => {
      callback(newValue, oldValue);
    });
  }
}

export function resetStore() {
  Object.keys(Store).forEach((path) => {
    if (!(path in initialState)) {
      console.warn(
        `Unknown key ${path} encountered in Store. Please add this key so it can be reset properly`
      );
      delete Store[path];
      return;
    }
    if (
      initialState[path] instanceof Object &&
      !Array.isArray(initialState[path])
    ) {
      // We only support one layer of nesting here so far. setValueAtPath the
      // subpaths to catch any listeners on deep paths
      Object.keys(initialState[path]).forEach((subPath) => {
        setValueAtPath(`${path}.${subPath}`, initialState[path][subPath]);
      });
    }
    setValueAtPath(path, initialState[path]);
  });
}

export default Store;



// WEBPACK FOOTER //
// ./src/flux_like/store/index.js